import incidentsService from './ws';

export default incidentsService;